export function getScrollableParent(
  element: HTMLElement | null,
): HTMLElement | null {
  if (element === null) {
    return null;
  }

  if (element.scrollHeight > element.clientHeight) {
    return element.parentElement;
  }
  return getScrollableParent(element.parentElement);
}
